import { AuthMenu } from "./AuthMenu.js"
import styles from "./SiteHeader.module.css"
import { SiteLogo } from "./SiteLogo.js"

export function SiteHeader() {
  return (
    <header className={styles.header}>
      <div className={styles.headerInner}>
        <SiteLogo />
        <div className={styles.authSlot}>
          <AuthMenu />
        </div>
      </div>
    </header>
  )
}
